<template>
  <div
    v-if="userBillingList.length"
    class="sm-plans__charges"
  >
    <div class="sm-plans__controls">
      <div class="sm-plans__controls-left">
        <h4>Charges</h4>
        <!-- <dropdown-block
          v-model="month"
          class="sm-dropdown"
          :options="monthNames"
          :searchable="false"
        >
          <template slot="singleLabel" slot-scope="props">
            <span>{{ props.option }}</span>
            <include-svg :name="'icon-arrow-b'" />
          </template>
        </dropdown-block> -->
      </div>
    </div>

    <div class="sm-plans__charges-table">
      <div class="sm-mobile-table sm-plans__charges-table-mobile">
        <div class="sm-mobile-table-item header">
          <div class="sm-mobile-table-item-row">
            <div class="sm-mobile-table-item-row-th control-arrow"></div>
            <div class="sm-mobile-table-item-row-th description">Description</div>
            <div
              v-if="viewPort == 'large'"
              class="sm-mobile-table-item-row-th date"
            >Issue Date</div>
            <div
              v-if="viewPort == 'large'"
              class="sm-mobile-table-item-row-th date"
            >Charge Date</div>
            <div
              v-if="viewPort == 'large'"
              class="sm-mobile-table-item-row-th amount"
            >Usage</div>
            <div
              v-if="viewPort == 'large'"
              class="sm-mobile-table-item-row-th amount"
            >Payment</div>
            <div
              v-if="viewPort == 'large'"
              class="sm-mobile-table-item-row-th refunded"
            >Refunded</div>
            <div
              v-if="viewPort == 'large'"
              class="sm-mobile-table-item-row-th balance"
            >Balance due</div>
            <div
              v-if="viewPort == 'large'"
              class="sm-mobile-table-item-row-th status"
            >Status</div>
            <div class="sm-mobile-table-item-row-th action"></div>
          </div>
        </div>
        <div
          v-for="item in userBillingList"
          :key="item.id"
          class="sm-mobile-table-item"
          :class="{
            'open': item.isOpen
          }"
        >
          <div
            class="sm-mobile-table-item-row"
            @click="toggleItem(item)"
          >
            <div class="sm-mobile-table-item-row-elem control-arrow">
              <include-svg :name="'icon-arrow-b-big'" />
            </div>
            <div class="sm-mobile-table-item-row-elem description">
              <text-truncate :text="`Invoice #${item.id}`" />
            </div>
            <div
              v-if="viewPort == 'large'"
              class="sm-mobile-table-item-row-elem date"
            >{{item.created_at | moment('MMM D, YYYY')}}</div>
            <div
              v-if="viewPort == 'large'"
              class="sm-mobile-table-item-row-elem date"
            >{{item.finalized_on | moment('MMM D, YYYY')}}</div>
            <div
              v-if="viewPort == 'large'"
              class="sm-mobile-table-item-row-elem amount"
            >{{formatPrice(item.total_usage)}}</div>
            <div
              v-if="viewPort == 'large'"
              class="sm-mobile-table-item-row-elem amount"
            >{{formatPrice('-' + item.total_payment)}}</div>
            <div
              v-if="viewPort == 'large'"
              class="sm-mobile-table-item-row-elem refunded"
            >{{formatPrice(item.refunded)}}</div>
            <div
              v-if="viewPort == 'large'"
              class="sm-mobile-table-item-row-elem balance"
            >{{formatPrice(item.ballance_due)}}</div>
            <div
              v-if="viewPort == 'large'"
              class="sm-mobile-table-item-row-elem status sm-txt-capitalize"
            >
              <div
                :class="{
                  'paid': item.status == 'Paid',
                  'refunded': item.status == 'Refunded' || item.status == 'Pending',
                  'partially-refunded': item.status == 'Partially Refunded',
                  'failed': item.status == 'Failed' || item.status == 'Canceled'
                }"
              >
                <include-svg
                  v-if="item.status == 'Refunded'"
                  :name="'icon-charges-refunded'"
                />
                <include-svg
                  v-if="item.status == 'Partially Refunded'"
                  :name="'icon-charges-partially-refunded'"
                />
                <span>{{item.status}}</span>
              </div>
            </div>
            <div
              class="sm-mobile-table-item-row-elem action sm-txt-right"
              @click.stop
            >
              <a
                v-if="item.invoice_pdf_url"
                :href="`${domain}${item.invoice_pdf_url.replace('/v1/', '')}`"
                class="icon"
                target="_blank"
                @click.stop
              >
                <include-svg :name="'icon-download'" />
              </a>
            </div>
          </div>
          <ul class="sm-mobile-table-item-dropdown">
            <template v-if="viewPort != 'large'">
              <li>
                <span class="sm-txt-strong">Issue Date</span>
                <span>{{item.created_at | moment('MMMM D, YYYY')}}</span>
              </li>
              <li>
                <span class="sm-txt-strong">Charge Date</span>
                <span>{{item.finalized_on | moment('MMMM D, YYYY')}}</span>
              </li>
              <li>
                <span class="sm-txt-strong">Usage</span>
                <span>{{formatPrice(item.total_usage)}}</span>
              </li>
              <li>
                <span class="sm-txt-strong">Payment</span>
                <span>{{formatPrice('-' + item.total_payment)}}</span>
              </li>
              <li>
                <span class="sm-txt-strong">Refunded</span>
                <span>{{formatPrice(item.refunded)}}</span>
              </li>
              <li>
                <span class="sm-txt-strong">Balance due</span>
                <span>{{formatPrice(item.ballance_due)}}</span>
              </li>
              <li>
                <span class="sm-txt-strong">Status</span>
                <span
                  :class="{
                    'paid': item.status == 'Paid',
                    'refunded': item.status == 'Refunded' || item.status == 'Pending',
                    'partially-refunded': item.status == 'Partially Refunded',
                    'failed': item.status == 'Failed'
                  }"
                >
                  <include-svg
                    v-if="item.status == 'Refunded'"
                    :name="'icon-charges-refunded'"
                  />
                  <include-svg
                    v-if="item.status == 'Partially Refunded'"
                    :name="'icon-charges-partially-refunded'"
                  />
                  <span>{{item.status}}</span>
                </span>
              </li>
              <li>
                <span class="sm-txt-strong">Items:</span>
              </li>
            </template>
            <li
              v-for="(entry, index) in item.items"
              :key="index"
            >
              <span>{{entry.created_at | moment('MMMM D, YYYY')}}</span>
              <span><template v-if="entry.type == 'refund'">Refund: </template>{{entry.description}}</span>
              <span class="sm-txt-right">{{formatPrice(entry.amount)}}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <btn-block
      v-if="canShowMore"
      :type="'show'"
      :text="'Show more'"
      :icon="'icon-arrow-round'"
      @click="requestMore"
    />

    <sm-spinner :show="showSpinner" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import {FormatPrice} from '@/utils/general-data';
// import Months from '@/settings/month';
import Spinner from '@/components/Spinner';
import Multiselect from 'vue-multiselect';
import Urls from '@/settings/urls';
import ViewPort from '@/mixins/ViewPort';

export default {
  name: 'billing-charges',
  components: {
    'sm-spinner': Spinner,
    'dropdown-block': Multiselect,
  },
  data() {
    return {
      domain: Urls.domain,
      showSpinner: false,
      userBillingList: [],

      //TEMP data
      // monthNames: Months.en,
      // month: 'May',

      allowedBreakpoints: [
        'small',
        'medium',
        'large'
      ],
      canShowMore: false,
      morePages: 0
    };
  },
  created() {
    this.getCharges();
  },
  computed: {
    ...mapGetters({
      provider: 'provider',
      isMobile: 'isMobile',
    })
  },
  mixins: [ViewPort],
  methods: {
    ...mapActions({
      getUserCharges: 'account/getUserCharges',
      showGlobalNotification: 'showGlobalNotification',
    }),
    formatPrice: FormatPrice,
    getCharges(params) {
      if (!params)
        params = {};

      this.showSpinner = true;
      this.getUserCharges(params)
        .then((list) => {
          if (list && list.charges && list.charges.length) {
            this.canShowMore = list.total_pages > list.page;

            this.prepareBillingList(list.charges)
              .then(preparedList => {
                this.userBillingList = [...this.userBillingList, ...preparedList];
                this.showSpinner = false;
              });
          } else {
            this.canShowMore = false;
            this.showSpinner = false;
          }
        })
        .catch(e => {
          if (this.provider.payment_gateway == 'stripe' && e.response.data && e.response.data.errors && e.response.data.errors.base) {
            this.showGlobalNotification({
              type: 'error',
              value: e.response.data.errors.base
            });
          }

          this.showSpinner = false;
        });
    },
    prepareBillingList(charges) {
      return Promise.all(charges.map((item) => {
        return new Promise((resolve, reject) => {
          const temp = {...item};
          temp.isOpen = false;
          temp.link = '#'; // TEMP
          // Here get link .then resolve(temp)
          resolve(temp);
        });
      }));
    },
    toggleItem(item) {
      item.isOpen = !item.isOpen;
    },
    requestMore() {
      this.morePages++;
      this.getCharges({
        page: this.morePages + 1
      });
    }
  }
}
</script>
